const LISTAR_DADOS = (state, payload) => {
    state.items = payload
}

const LISTAR_DADOS_WORKFLOWS = (state, payload) => {
    state.itemsWorkflows = payload
}

const CARREGANDO = (state, payload) => {
  state.carregando = payload
}

const LISTAR_DADOS_TAREFA = (state, payload) => {
  state.itemsPcoTarefas = payload
}

const INSERIR_TAREFA_SELECIONADA = (state, payload) => {
  state.tarefaSelecionada = payload;
}

const LISTAR_TOTAIS_TAREFA = (state, payload) => {
  state.totais = payload
}

export {
    LISTAR_DADOS,
    LISTAR_DADOS_WORKFLOWS,
    CARREGANDO,
    LISTAR_DADOS_TAREFA,
    INSERIR_TAREFA_SELECIONADA,
    LISTAR_TOTAIS_TAREFA
}